var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9419 4.44194C13.186 4.19786 13.186 3.80214 12.9419 3.55806C12.6979 3.31398 12.3021 3.31398 12.0581 3.55806L8.5 7.11612L4.94194 3.55806C4.69786 3.31398 4.30214 3.31398 4.05806 3.55806C3.81398 3.80214 3.81398 4.19786 4.05806 4.44194L7.61612 8L4.05806 11.5581C3.81398 11.8021 3.81398 12.1979 4.05806 12.4419C4.30214 12.686 4.69786 12.686 4.94194 12.4419L8.5 8.88388L12.0581 12.4419C12.3021 12.686 12.6979 12.686 12.9419 12.4419C13.186 12.1979 13.186 11.8021 12.9419 11.5581L9.38388 8L12.9419 4.44194Z",
    fill: "#343839"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4a47cd8bb8c4ce85d251a340773d4f15.svg";
export { ForwardRef as ReactComponent };